import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { BoxIcon, UtensilsIcon, Loader2Icon, ScissorsIcon, PackageIcon, GripVerticalIcon, PlusIcon, XIcon } from 'lucide-react';
import { ShurikenIcon } from './icons/ShurikenIcon';
const availableProductionSteps = [{
  id: 'kutterei',
  label: 'Kutterei',
  icon: ShurikenIcon
}, {
  id: 'fuellerei',
  label: 'Füllerei',
  icon: UtensilsIcon
}, {
  id: 'raeucherei',
  label: 'Räucherei',
  icon: Loader2Icon
}, {
  id: 'schaelerei',
  label: 'Schälerei',
  icon: ScissorsIcon
}, {
  id: 'verpackung',
  label: 'Verpackung',
  icon: PackageIcon
}] as const;
function DragDropProductionSteps({
  selectedSteps,
  onStepsChange
}: {
  selectedSteps: typeof availableProductionSteps;
  onStepsChange: (steps: typeof availableProductionSteps) => void;
}) {
  const handleDragEnd = (result: any) => {
    if (!result.destination) return;
    const items = Array.from(selectedSteps);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    onStepsChange(items);
  };
  const addStep = (step: (typeof availableProductionSteps)[0]) => {
    if (!selectedSteps.find(s => s.id === step.id)) {
      onStepsChange([...selectedSteps, step]);
    }
  };
  const removeStep = (stepId: string) => {
    onStepsChange(selectedSteps.filter(step => step.id !== stepId));
  };
  return <div className="space-y-4" data-id="element-567">
      <div className="bg-gray-50 rounded-lg p-4" data-id="element-568">
        <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-569">
          Verfügbare Produktionsschritte
        </h4>
        <div className="flex flex-wrap gap-2" data-id="element-570">
          {availableProductionSteps.map(step => {
          const Icon = step.icon;
          const isSelected = selectedSteps.some(s => s.id === step.id);
          return <button key={step.id} onClick={() => addStep(step)} disabled={isSelected} className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm
                  ${isSelected ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white hover:bg-gray-50 text-gray-700'}`} data-id="element-571">
                <Icon className="h-4 w-4" data-id="element-572" />
                <span data-id="element-573">{step.label}</span>
              </button>;
        })}
        </div>
      </div>
      <DragDropContext onDragEnd={handleDragEnd} data-id="element-574">
        <Droppable droppableId="productionSteps" data-id="element-575">
          {provided => <div {...provided.droppableProps} ref={provided.innerRef} className="min-h-[400px]" data-id="element-576">
              {selectedSteps.length === 0 ? <div className="text-center py-8 text-gray-500 border-2 border-dashed border-gray-200 rounded-lg" data-id="element-577">
                  Fügen Sie Produktionsschritte hinzu
                </div> : <div className="space-y-2" data-id="element-578">
                  {selectedSteps.map((step, index) => {
              const Icon = step.icon;
              return <Draggable key={step.id} draggableId={step.id} index={index} data-id="element-579">
                        {provided => <div ref={provided.innerRef} {...provided.draggableProps} className="flex items-center justify-between bg-white rounded-lg border border-gray-200 p-3" data-id="element-580">
                            <div className="flex items-center gap-3" data-id="element-581">
                              <div {...provided.dragHandleProps} data-id="element-582">
                                <GripVerticalIcon className="h-5 w-5 text-gray-400" data-id="element-583" />
                              </div>
                              <div className="flex items-center gap-2" data-id="element-584">
                                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-585">
                                  <Icon className="h-4 w-4 text-gray-600" data-id="element-586" />
                                </div>
                                <span className="font-medium" data-id="element-587">
                                  {step.label}
                                </span>
                              </div>
                            </div>
                            <button onClick={() => removeStep(step.id)} className="text-gray-400 hover:text-red-500" data-id="element-588">
                              <XIcon className="h-5 w-5" data-id="element-589" />
                            </button>
                          </div>}
                      </Draggable>;
            })}
                </div>}
              {provided.placeholder}
            </div>}
        </Droppable>
      </DragDropContext>
    </div>;
}
export { DragDropProductionSteps, availableProductionSteps };